import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Button, Modal } from 'react-bootstrap';
import HotelAddDetailContainer from './HotelAddDetailContainer';

class HotelAddModal extends React.Component {
  render() {
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find Hotel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <HotelAddDetailContainer
              event={this.props.event}
              displayHotel={this.props.displayHotel}
            />
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

HotelAddModal.propTypes = {
  event: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

export default HotelAddModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelAddModal.js